import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';
import AnimateHeight from 'react-animate-height';
import isEmpty from '../../utils/isEmpty';
import Map from '../Map';
import Button from '../Button';
import styles from './MapExpander.module.scss';

const MapExpander = ({ googleMapsApiKey, items = [], zoomLevel = 14 }) => {
    const { t } = useTranslation('common');
    const [isOpen, setIsOpen] = useState(false);

    if (isEmpty(items)) {
        return null;
    }

    items = items.map((item) => ({
        ...item,
        readMore: item?.url ? null : t('mapExpander.goToMap'),
        href: item?.url || `https://maps.google.com/maps/dir/${item.lat},${item.lng}/@${item.lat},${item.lng},16z`,
    }));

    return (
        <div className={styles['MapExpander']}>
            <Button
                type="Primary"
                subType="IsMapExpander"
                icon="Plus"
                onClick={() => setIsOpen((p) => !p)}
                aria-controls="article_map"
                aria-expanded={isOpen}
                className={styles['MapExpander__Button']}>
                {t('mapExpander.defaultIfNoAddress')}
            </Button>
            <AnimateHeight
                duration={350}
                height={isOpen ? 'auto' : 0}
                id="article_map"
                role="region"
                className={styles['MapExpander__AnimationWrapper']}
                contentClassName={styles['MapExpander__Expand']}>
                <Map
                    apiKey={googleMapsApiKey}
                    items={items}
                    zoomLevel={zoomLevel}
                    untranslatedModifiers={['Map--InExpander']}
                />
            </AnimateHeight>
        </div>
    );
};

MapExpander.propTypes = {
    googleMapsApiKey: PropTypes.string,
    items: PropTypes.array,
    zoomLevel: PropTypes.number,
};

export default MapExpander;
